import { recordStringValue } from "src/common/utils/table";
import { ReviewTask } from "./model/ReviewTasks";
import { isNullOrUndefined } from "src/common/utils";
import { WarningConfirmations } from "src/common/data/warning-confirmation-messages";

type AntdColumnSorterForReviewTasksType = (
  recordA: ReviewTask,
  recordB: ReviewTask,
  sortOrder: string
) => number;

function sortTasksByUserAndIsEditable(
  recordA: ReviewTask,
  recordB: ReviewTask,
  sortOrder: string,
  column
): number {
  const multiplier = sortOrder === "descend" ? -1 : 1;
  if (column.title !== "User") {
    const recordAUserValue = recordStringValue(recordA, "User");
    const recordBUserValue = recordStringValue(recordB, "User");
    if (recordAUserValue.localeCompare(recordBUserValue) !== 0) {
      return recordAUserValue.localeCompare(recordBUserValue) * multiplier;
    }
  }
  if (recordA.hasEditAccess === true && recordB.hasEditAccess === false) {
    return -1 * multiplier;
  } else if (recordA.hasEditAccess === false && recordB.hasEditAccess === true) {
    return 1 * multiplier;
  }
  return 0;
}

function DefaultSorterForReviewTasks(column: any): AntdColumnSorterForReviewTasksType {
  return (recordA: ReviewTask, recordB: ReviewTask, sortOrder: string): number => {
    const recordAValue = recordStringValue(recordA, column.dataIndex);
    const recordBValue = recordStringValue(recordB, column.dataIndex);
    if (recordAValue.localeCompare(recordBValue) !== 0) {
      return recordAValue.localeCompare(recordBValue);
    }
    return sortTasksByUserAndIsEditable(recordA, recordB, sortOrder, column);
  };
}

function CustomSorterForReviewTasks(column: any): AntdColumnSorterForReviewTasksType {
  return (recordA: ReviewTask, recordB: ReviewTask, sortOrder: string): number => {
    if (column.sorter(recordA, recordB) !== 0) {
      return column.sorter(recordA, recordB);
    }
    return sortTasksByUserAndIsEditable(recordA, recordB, sortOrder, column);
  };
}

export function addCustomizedSorterLogicToColumns(columns: any): any {
  return columns.map((column) => {
    const { sortEnabled, singleSort, sorter, ...restProps } = column;
    if (sortEnabled === true || singleSort === true) {
      return {
        sorter: isNullOrUndefined(sorter)
          ? DefaultSorterForReviewTasks(column)
          : CustomSorterForReviewTasks(column),
        sortEnabled,
        singleSort,
        ...restProps,
      };
    }
    return column;
  });
}

export function addSortWarningToColumns(columns: any): any {
  return columns.map((column) => {
    const { sortEnabled, singleSort, title, ...restProps } = column;
    if ((sortEnabled === true || singleSort === true) && title !== "User") {
      return {
        sortEnabled,
        singleSort,
        title,
        sortWarningConfirmation: {
          id: WarningConfirmations.ReviewTaskUserSortWillBreak.id,
          popOverPlacement: title === "Delegation" ? "topLeft" : null,
        },
        ...restProps,
      };
    }
    return column;
  });
}
